export const LABELS_SINGLE_VOYAGE = {
    navigate: {
        monitoring: "Моніторинг",
        planned: "Заплановані",
        active: "Активні",
        archive: "Архів",
        tasksTemplate: "Шаблони доручень",
        pointTemplates: "Шаблони зупинок",
        voyageTemplates: "Шаблони рейсів",
        planning: "Планування",
        trackableObjects: "Об’єкти з мітками",
        readers: "Зчитувачі",
        video: "Відео",
        reports: "Звіти",
    },
    tasksTemplates: "Шаблони доручень",
    voyageTemplate: {
        badge: {
            column: "Шаблон",
            fromTemplate: "З шаблону «{{title}}»",
            deleted: "шаблон видалено",
            diverged: "змінено вручну",
            outdated: "відрізняється від шаблону",
            outdatedHint: "Шаблон змінився, а рейс ще ні — натисніть, щоб оновити його за шаблоном.",
            divergedHint: "Маршрут або час рейсу змінено вручну — оновлення з шаблону пропускає його, поки не позначити примусово.",
        },
        deleteWithVoyages: "З цього шаблону заплановано рейсів: {{count}}. Вони лишаться, але більше не оновлюватимуться за шаблоном і зникнуть із сітки планування. Видалити шаблон?",
        create: "Створити шаблон рейсу",
        settings: "Налаштування шаблону",
        startTime: "Час початку",
        endTime: "Час кінця",
        duration: "Тривалість",
        crossesMidnight: "через північ",
        startTimeInvalidMessage: "Невірний час початку",
        endTimeInvalidMessage: "Невірний час кінця",
        endTimeEqualsStartMessage: "Час кінця має відрізнятись від часу початку",
        notFound: "Не знайдено даний шаблон рейсу...",
        createStopHere: "Створити зупинку тут",
        stopCatalog: "Каталог зупинок",
        hideStopCatalog: "Приховати каталог зупинок",
        deleteByRightClick: "правий клік — видалити рейс",
        planning: "Планування з шаблонів",
        plan: "Запланувати",
        planningHint: "Оберіть діапазон дат — і для кожного шаблону можна створити рейс на потрібний день. Час початку й тривалість беруться з шаблону, активація завжди по графіку.",
        pastSlotHint: "Час початку вже минув — рейс із активацією по графіку створити не можна",
        driverNotifiedHint: "Водій отримає push-повідомлення про рейс одразу після створення.",
        createFromVoyage: "Зберегти як шаблон рейсу",
        confirmCreateFromVoyage: "Створити шаблон рейсу на основі цього рейсу? Маршрут, зупинки, час початку та тривалість буде скопійовано.",
        createdFromVoyage: "Шаблон рейсу створено — він у розділі «Шаблони рейсів»",
        manualVoyageTimeHint: "Ручний рейс не має планового вікна — вкажіть, у які години цей рейс має виконуватись за шаблоном.",
        editStop: {
            open: "Редагувати зупинку",
            title: "Редагування зупинки",
            hint: "Перетягніть маркер на карті, щоб перемістити зупинку. Зміни зберігаються в самій зупинці й стосуються всіх шаблонів рейсів, де вона є.",
            savedSaveTemplate: "Зупинку збережено. Збережіть шаблон — далі можна буде оновити рейси, де вона є.",
            rebuildFailed: "Зупинку збережено, але маршрут за її новим положенням перебудувати не вдалося.",
            retry: "Перебудувати маршрут ще раз",
        },
        sync: {
            open: "Оновити заплановані рейси",
            outdatedCount: "Рейсів, що відрізняються від шаблону: {{count}} — оновити",
            title: "Оновити заплановані рейси шаблону",
            hint: "Рейси, створені з цього шаблону, буде приведено до нього: зупинки, їх порядок, маршрут і час. Авто, водій, назва та доручення лишаються як є.",
            noVoyages: "Усі заплановані рейси вже відповідають шаблону.",
            stops: "Зупинки маршруту",
            voyages: "Заплановані рейси: {{count}}",
            later: "Пізніше",
            close: "Закрити",
            apply: "Оновити рейси: {{count}}",
            result: "Оновлено рейсів: {{updated}}, пропущено: {{skipped}}",
            divergedHint: "Рейс змінено вручну ({{date}}). Позначте, щоб перезаписати його за шаблоном.",
            forceWarning: "Позначені рейси, змінені вручну, буде перезаписано за шаблоном — ручні зміни в них втратяться.",
            routeStale: "Маршрут застарів: зупинку перемістили. Відкрийте шаблон, щоб перебудувати маршрут.",
            routeStaleShort: "Маршрут застарів",
            rebuildRoute: "Перебудувати маршрут",
            routeRebuilt: "Маршрут перебудовано за новим положенням зупинок — перевірте та збережіть шаблон.",
            stopUsedIn: "Зупинка використовується в шаблонах рейсів",
            stopUsedInHint: "Заплановані рейси цих шаблонів можна оновити. Якщо зупинку перемістили, спершу перебудуйте маршрут шаблону.",
            stopUsedInCount: "Шаблонів рейсів: {{count}}",
            movedDraft: "Зупинку переміщено. Нова позиція застосується після збереження змін.",
            movedDraftCancel: "Повернути на місце",
            summary: {
                ready: "оновиться: {{count}}",
                updated: "оновлено: {{count}}",
                diverged: "змінено вручну: {{count}}",
                skipped: "пропущено: {{count}}",
            },
            wasNumber: "було №{{number}}",
            unchangedStops: "№{{from}}–№{{to}} без змін ({{count}} зуп.) — показати",
            unchangedShort: "{{count}} без змін",
            collapse: "згорнути",
            movedStopTooltip: "№{{number}} переміщено",
            movedStopTooltipDistance: "№{{number}} переміщено на {{distance}} м",
            oldStopTooltip: "№{{number}} — стара позиція",
            movedStopLabel: "Переміщено — маршрут перебудовано",
            rebuiltTitle: "Маршрут перебудовано за новим положенням зупинок",
            rebuiltMoved: "Переміщено зупинки: №{{numbers}}",
            rebuiltCheck: "Перевірте маршрут і збережіть шаблон.",
            divergedBanner: "Цей рейс змінювали вручну (останнє збереження {{date}}). Відмінності нижче — це і ручні правки, і зміни шаблону; якщо оновити рейс, усе стане як у шаблоні.",
            detail: {
                moved: "зсув на {{value}} м",
                NAME: "назва",
                ADDRESS: "адреса",
                RADIUS: "радіус",
                TYPE: "тип",
                TIMES: "планові часи на зупинці буде скинуто",
                metres: "{{value}} м",
                types: {
                    POINT_RADIUS: "звичайна",
                    RFID_POINT: "RFID",
                    POLYGON: "полігон",
                },
            },
            legend: {
                newRoute: "новий маршрут",
                oldRoute: "старий маршрут",
                changedRoute: "змінена ділянка",
                movedStop: "переміщена зупинка",
                added: "додана",
                changed: "змінена",
                oldPosition: "стара позиція",
                removed: "прибрана",
            },
            outcome: {
                READY: "Буде оновлено",
                UPDATED: "Оновлено",
                DIVERGED: "Змінено вручну",
                TOO_LATE: "Стартує надто скоро",
                TASKS_ON_REMOVED_STOP: "Доручення на прибраній зупинці",
                DEVICE_BUSY: "Авто зайняте в цей час",
                INVALID: "Не можна оновити",
                NOT_FOUND: "Рейс не знайдено",
            },
            change: {
                ROUTE: "Змінено маршрут",
            },
        },
    },
    createVoyage: "Створити рейс",
    monitoring: {
        stopsProgress: "{{done}} з {{total}} зупинок",
        updatedAt: "оновлено {{time}}",
        minutesAgo: "{{count}} хв тому",
        hoursAgo: "{{count}} год тому",
        justNow: "щойно",
        noDevice: "ТЗ не призначено",
        noDeviceData: "даних з ТЗ ще немає",
        noDriver: "без водія",
        plannedShort: "пл.",
        now: "зараз",
        kmH: "км/год",
        motion: {
            motion: "У русі",
            parking: "Стоянка",
            stopping: "Зупинка",
            unknown: "Немає зв'язку",
        },
        openActiveVoyage: "Відкрити активний рейс",
    },
    pointName: "Назва зупинки",
    reorderPoints: "Змінити порядок зупинок",
    showVoyage: "Переглянути рейс",
    subtasks: "Підоручення",
    taskCount: "Кількість доручень",
    updateTasks: "Оновити дорученя",
    plannedArrival: "Планове прибуття",
    createTrack: "Побудувати трек",
    track: "Трек",
    completePoints: "Виконано зупинок",
    completeTasks: "Виконано доручень",
    changeAssignment: "Змінити виконавця",
    isNotCompleteCurrentTargetAssignment: "Оброблена іншим виконавцем",
    selectAssignment: "Виберіть виконавця",
    loadedOldTasks: "Підвантажити доручення на основі рейсу",
    nothingData: "Даних поки немає...",
    saveAndSchedule: 'Зберегти та запланувати',
    addTaskTemplate: 'Додати шаблон доручення',
    taskDetailsType: 'Шаблон доручення',
    basicTaskDetailsType: 'Базовий',
    photoRequired: 'Фотозвіт',
    unitDelivery: 'Доставка',
    reports: 'Звіти',
    reportExecution: 'Звіт про роботу рейса',
    reportRfid: {
        title: 'Звіт по RFID-мітках',
        plannedSites: 'Точок план',
        visitedSites: 'Точок відвідано',
        plannedBins: 'Міток план',
        uniqueBinsServed: 'Зчитано унікальних',
        binStates: {
            read: 'Вивезено',
            readOutsideGeofence: 'Вивезено (поза геозоною)',
            notRead: 'Не зчитано',
            readAtOtherSite: 'Інша точка',
            readAtOtherSiteNamed: 'Зчитано на «{{site}}»',
            readNotCredited: 'Зчитано, не зараховано',
            foreignBin: 'Чужий бак',
            unplannedBin: 'Позаплановий',
        },
        sheet: {
            title: 'Звіт про вивезення ТПВ',
            voyageLine: 'Рейс №{{id}} «{{title}}»',
            generatedAt: 'сформовано {{value}}',
            print: 'Друк',
            excel: 'Зберегти в Excel',
            pdf: 'Зберегти PDF',
            driver: 'Водій',
            vehicle: 'Транспорт',
            duration: 'Рейс тривав',
            distance: 'Пробіг',
            stops: 'Зупинок',
            bins: 'Контейнерів',
            served: 'Вивезено',
            notRead: 'Не зчитано',
            otherSite: 'Інша точка',
            notCredited: 'Не зараховано',
            unplanned: 'Позапланові',
            arrival: 'заїзд',
            departure: 'виїзд',
            onSite: 'на точці',
            minutesShort: 'хв',
            kmShort: 'км',
            siteBins: 'контейнерів',
            siteServed: 'вивезено',
            siteNotRead: 'не зчитано',
            siteOtherSite: 'зчитано на іншій точці',
            siteNotCredited: 'не зараховано',
            siteUnplanned: 'позапланових',
            columnNumber: '№',
            columnBin: 'Контейнер',
            columnTag: 'Мітка',
            columnState: 'Стан',
            columnTime: 'Час',
            columnReads: 'Разів',
            columnNote: 'Примітка',
            noTag: 'без мітки',
            noTagNote: 'мітка не заведена',
            outsideGeofence: 'поза геозоною',
            repeatLift: 'повторний підйом',
            totalLine: 'Разом по рейсу: {{bins}} контейнерів, вивезено {{served}}, виконання {{percent}} %',
            outsideSitesLine: ', поза зупинками {{count}}',
            signature: 'підпис відповідального',
            noBins: 'На точці немає контейнерів',
            noSites: 'У рейсі немає точок із контейнерами',
            expandAll: 'Розгорнути всі',
            collapseAll: 'Згорнути всі',
            scanned: 'зчитано {{read}} з {{total}}',
            videos: 'Відео з зупинки',
            videosCount: 'Відео з зупинки ({{count}})',
        },
    },
    reportSheet: {
        backToVoyages: 'До разових рейсів',
        executionTitle: 'Звіт про роботу рейсів',
        rfidTitle: 'Звіт по RFID-мітках',
        dailyTitle: 'Виконання рейсів за день',
        period: 'Період {{start}} — {{end}}',
        day: 'За {{day}}',
        voyagesList: 'Рейси',
        openHint: 'Натисніть на рейс, щоб відкрити детальний звіт',
        empty: 'За обраний період рейсів немає',
        voyages: 'Рейсів',
        drivers: 'Водіїв',
        vehicles: 'Транспорту',
        stops: 'Зупинок',
        bins: 'Контейнерів',
        served: 'Вивезено',
        completion: 'Виконання',
        distance: 'Пробіг, км',
        onRoute: 'По маршруту, км',
        outRoute: 'Поза маршрутом, км',
        columnNumber: '№',
        columnVoyage: 'Рейс',
        columnStatus: 'Статус',
        columnDriver: 'Водій',
        columnVehicle: 'Транспорт',
        columnFact: 'Факт',
        columnDuration: 'Тривалість',
        columnWork: 'Робота',
        columnStops: 'Зупинки',
        columnBins: 'Контейнери',
        columnCompletion: 'Виконання',
        columnDistance: 'Пробіг, км',
        columnOnRoute: 'По маршруту',
        columnOutRoute: 'Поза',
    },
    reportDailyExecution: {
        title: 'Виконання за день',
        breadcrumb: 'Виконання рейсів за день',
        day: 'День',
        totals: 'Разом за день',
        voyagesCount: 'Рейсів',
        sites: 'Точок відвідано / план',
        bins: 'Міток зчитано / план',
        onRouteDistance: 'Пробіг по маршруту, км',
        outRouteDistance: 'Пробіг поза маршрутом, км',
        totalDistance: 'Загальний пробіг, км',
        vehicle: 'Машина',
        allVoyages: 'Усі рейси дня',
        vehicleSheet: {
            title: 'Аркуш машини за день',
            issued: 'Видано',
            vehicle: 'Машина',
            date: 'Дата',
            columnNumber: '№ п/п',
            columnName: 'Назва зупинки',
            columnAddress: 'Адреса',
            columnBins: 'К-сть контейнерів',
            columnVolume: "Об'єм",
            columnSchedule: 'Графік, {{weekday}}',
            columnTrip: 'Ходка {{number}}',
            columnNote: 'Примітка',
            empty: 'Цього дня машина не мала рейсів',
        },
    },
    addSubtask: 'Додати піддорученя',
    // DEPRECATED: a duplicate of taskStatuses (below), missing cancelled and with
    // typos. Its only consumer, getLabelStatusTaskSingleVoyage, now uses taskStatuses.
    //
    // tasksStatuses:{
    //     planned:"Запланована",
    //     inProgress:"В процесі",
    //     completed:"Виконанна",
    //     partialCompleted:"Частково виконанна",
    //     deleted:"Видалена",
    // },
    taskTemplate: "Шаблон доручення",
    errorCreateTasks: "Помилка при створенні доручень.",
    noLimit: 'Без ліміту',
    planCompletionTime: 'Запланований час виконання',
    singleWaypointLimit: 'Одна зупинка',
    waypointLimit: 'Ліміт',
    changeAdjustingPoints: 'Змінити корегуючи точки',
    searchPointsFromPastVoyages: 'Знайти зупинку з минулих рейсів',
    searchPoints: 'Знайти зупинку',
    saveAdjustingPoints: 'Зберегти корегуючи точки',
    confirmBuildPositionsMessage: 'Ви впевненні що бажаєте продовжити? Це призведе до можливого очищення корегуючих точок',
    estimatedTimeArrival: "Плановий час прибуття",
    scheduledVoyages: "Заплановані рейси",
    activeVoyages: "Активні рейси",
    activeVoyage: "Активний рейс",
    realTimeArrival: "Реальний час прибуття",
    plannedStayStop: "Планове перебування в зуп.",
    realStayStop: "Реальне перебування в зуп.",
    status: "Статус",
    createNewVoyageFromCurrent: "Створити новий рейс на основі вибраного(розширена версія)",
    quickCreateNewVoyageFromCurrent: "Створити новий рейс на основі вибраного",
    quickCreateNewVoyageFromCurrentWithAutoTasksLoad: "Створити новий рейс на основі вибраного(з авто. підвантаженям доручень)",
    settingsRoute: "Налаштування маршруту",
    saveVoyage: "Зберегти маршрут",
    fixationRadiusGeozone: "Радіус фіксації (геозони)",
    numberStop: "Порядковий номер зупинки",
    countCompletedAssignments: "К-ть виконаних доручень",
    plannedStay: "Планове перебування",
    plannedStayStart: "Планове перебування від",
    plannedStayEnd: "Планове перебування до ",
    scheduledTime: "Плановий час",
    confirmDeleteScheduleVoyage: "Увага! Ви збираєтесь видалити запланований рейс, продовжити видалення?",
    historyVoyage: "Історія рейсу",
    assignment: "Завдання",
    dateTimeRouteStart: "Початок рейсу",
    dateTimeRouteEnd: "Кінець рейсу",
    plannedDateTimeRouteEnd: "Планований кінець рейсу",
    plannedDateTimeRouteStart: "Планований початок рейсу",
    factDateTimeRouteStart: "Фактичний початок рейсу",
    factDateTimeRouteEnd: "Фактичний кінець рейсу",
    tripIdAccordingToDatabase: "ID рейсу згідно бази час",
    progress: "Прогрес",
    deviceBusyOnStart: "Транспортний засіб зайнятий іншим рейсом. Завершіть його або оберіть інше авто.",
    deviceBookedForPlannedVoyage: "На цей транспортний засіб уже заплановано інший рейс. Якщо розпочати зараз, той рейс не стартує за графіком. Оберіть інше авто або скасуйте запланований рейс.",
    deviceWindowOverlap: "Транспортний засіб у цей час уже зайнятий іншим рейсом. Оберіть інший час або інше авто.",
    closeStops: {
        title: "Зупинки стоять надто близько",
        pair: "«{{first}}» і «{{second}}» — {{distance}} м одна від одної при радіусі {{radius}} м.",
        fixRadius: "Зменште радіус до {{radius}} м або об’єднайте їх в одну зупинку.",
        fixMerge: "Об’єднайте їх в одну зупинку: радіус не може бути меншим за {{radius}} м.",
        pairShort: "Зупинки {{first}} і {{second}}: між ними {{distance}} м, а радіус {{radius}} м.",
        resize: "Зменшити радіус до {{radius}} м",
        editStop: "Змінити шаблон зупинки {{number}}",
        remove: "Прибрати {{number}}",
        show: "Показати",
        lockedRadius: "Радіус зупинки з шаблону змінюється в «Шаблонах зупинок».",
        map: {
            title: "Зони зупинок {{first}} і {{second}} перекриваються",
            sizes: "Між центрами {{distance}} м. Радіус {{first}} — {{radiusFirst}} м, радіус {{second}} — {{radiusSecond}} м.",
            inside: "Центр зупинки {{inner}} лежить у зоні зупинки {{outer}} ({{depth}} м від краю): авто на ній уже й на іншій, і відвідування зарахується лише одній.",
            insideBoth: "Центр кожної зупинки лежить у зоні іншої ({{depth}} м від краю): авто на одній уже й на іншій, і відвідування зарахується лише одній.",
            near: "Від центру зупинки {{inner}} до зони зупинки {{outer}} лише {{gap}} м: авто, що стоїть трохи збоку від {{inner}}, уже в зоні {{outer}}.",
            nearBoth: "Від центру кожної зупинки до зони іншої лише {{gap}} м: авто, що стоїть трохи збоку від зупинки, уже в зоні сусідньої.",
            fixTitle: "Як виправити",
            fixRadius: "Радіус {{number}}: {{from}} → {{to}} м",
            fixTemplateRadius: "Радіус {{number}}: {{from}} → {{to}} м (у шаблоні зупинки)",
            orMerge: "або об’єднайте їх в одну зупинку.",
        },
        whyShort: "Авто на одній із них уже в зоні іншої, тож відвідування зарахується лише одній. Кілька контейнерів можна прив’язати до однієї зупинки.",
        apiErrorStops: "Деякі зупинки стоять у радіусі одна одної, тож відвідування зараховуватиметься лише одній із них. Зменште радіус або об’єднайте зупинки.",
        apiError: "Зупинка опиниться в радіусі іншої зупинки шаблону рейсу, і відвідування зараховуватиметься лише одній із них. Зменште радіус або оберіть інше місце.",
    },
    successStartVoyage: "Ви успішно розпочали рейс!",
    successArchiveVoyage: "Рейс перенесено в архів",
    archiveVoyage: "Архівувати",
    confirmArchiveVoyage: "Перенести рейс в архів? Він зникне зі списку запланованих, але лишиться в архіві — звідти можна створити копію.",
    successStopVoyage: "Ви успішно закінчили рейс!",
    licensePlate: "Номер ТЗ",
    completedTasksCount: "К-ть виконаних доручень",
    device: "Транпортний засіб",
    totalPointCount: "Загальна к-ть зупинок",
    driver: "Виконавець маршруту",
    optimalRouteControl: "Контроль руху по оптимальному маршруті",
    strictStopOrder: "Строга порядковість відвідування зупинок",
    notifyDriverAboutTrip: "Повідомити водія про рейс",
    tasks: "Доручення",
    nothingTasks: "Ви поки що не додали жодних завдань",
    nothingTasksInPoint: "На даній зупинці доручень немає",
    addTask: "Додати доручення",
    namePlaceholderTask: "Надайте коротку назву даному дорученню",
    descriptionPlaceholderTask: "Опишіть завдання конкретніше",
    photoReport: "Фотозвіт",
    hasPhotoReport: "Має Фотозвіт",
    trackArrivalTimeAtFirstStop: "Відслідковувати по часу прибуття за графіком першої зупинки",
    trackArrivalTimeAtLastStop: "Відслідковувати по часу прибуття за графіком останньої  зупинки",
    minPointLengthMessage: "Мінімальна кількість зупинок - 2",
    notFoundVoyage: "Не знайдено даний рейс...",
    updateVoyage: "Редагувати рейс",
    deleteVoyage: "Видалити рейс",
    statuses:{
        draft:'Чорновик',
        readyForManualRun:'Активація вручну',
        plannedForAutorun:'По графіку',
        manualRun:'Виконується',
        plannedRun:'Виконується',
        plannedManualRun:'Виконується',
        plannedCompleted:'Завершено по плану',
        plannedInterrupted:'Завершено достроково',
        manualCompleted:'Завершено вручну',
        deleted:'Видалений',
        notStartedDeviceBusy:'Не стартував: ТЗ зайняте',
        archived:'В архіві',
        readyForManualRunSelect:'Активація вручну',
        readyForManualRunSelectWithDate:'Активація вручну(з відображенням приблизної дати)',
        plannedForAutorunSelect:'Активація по графіку ',
    },
    selectRouteSegment: 'Оберіть ділянку маршруту',
    selectRouteSegmentHint: 'Між якими зупинками коригувати трек',
    statusFilter:{
        all:'Усі',
    },
    pointStatuses:{
        planned:'Запланована',
        completed:'Виконана',
        skipped:'Пропущена',
        inProgress:'В процесі',
        deleted:'Видалена',
        partialCompleted:'Виконана частково',
    },
    taskStatuses:{
        planned:'Запланована',
        completed:'Виконана',
        inProgress:'В процесі',
        deleted:'Видалена',
        cancelled:'Відмінена',
        partialCompleted:'Виконана частково',
    },
    taskActions: 'Дії з дорученням',
    taskStates: {
        planned: 'Не починали',
        running: 'Виконується',
        partial: 'Виконано частково',
        done: 'Виконано',
        failed: 'Не виконано',
    },
    tasksStopSummary: 'Доручення · {{done}} з {{total}}',
    executions: 'Зупинки доручення',
    selectAllWaypoints: 'Вибрати всі ({{count}})',
    clearAllWaypoints: 'Зняти вибір',
    markExecutionCompleted: 'Виконано',
    markExecutionCancelled: 'Не виконано',
    closeTask: 'Закрити доручення',
    closeTaskFully: 'Закрити доручення на всіх зупинках',
    closeTaskAsCompleted: 'Виконано на всіх зупинках',
    closeTaskAsCancelled: 'Не виконано на всіх зупинках',
    closeTaskConfirm: 'Дія застосується до всіх зупинок доручення: буде закрито {{open}} із {{total}}. Уже закриті не зміняться.',
    closeTaskNothingToClose: 'Усі зупинки вже закриті',
    photoRequiredToComplete: 'Для цієї зупинки потрібне фото',
    executionAlreadyClosed: 'Цю зупинку вже закрито',

    driverMessages: 'Повідомлення водія',
    voyageTitleLabel: 'Рейс: {{title}}',
    driverMessagesUnread: 'Непрочитаних від водія: {{count}}',
    driverMessagesEmpty: 'Переписки ще немає',
    driverMessagesEmptyHint: 'Напишіть водію — він отримає повідомлення в додатку.',
    driverMessagesPlaceholder: 'Написати водію…',
    driverNotAssigned: 'Водія не призначено',
    send: 'Надіслати',
    sendHint: 'Enter — надіслати, Shift+Enter — новий рядок',
    editHint: 'Esc — скасувати',
    today: 'Сьогодні',
    yesterday: 'Вчора',
    roleDriver: 'Водій',
    roleDispatcher: 'Диспетчер',

}
